export default __webpack_public_path__ + "static/media/wheelChair.efa73c33.svg";